import React, { useContext } from 'react';
import './style.css';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { AddressSearchContext } from '/src/App';

const RiskOverviewClimateIcon = ({
    id,
    risk_level,
    icon_white,
    icon_black,
    risk_name,
    handleMouseEnter,
    handleMouseLeave,
    notSelected,
    requiresLookup = false, // default to true for backward compatibility
    displayName = true
}) => {

    // console.log('RISKOVERVIEWCLIMATEICON INPUTS', {
    //     id,
    //     risk_level,
    //     icon_white,
    //     icon_black,
    //     risk_name,
    //     requiresLookup
    // })

    // Get the portalData from the AddressSearchContext
    const { portalData } = useContext(AddressSearchContext);
    const { icons ={}} = portalData;

    // Load icons from localStorage only if needed
    const iconsJson = requiresLookup ? icons : null;

    // Helper function to determine colors based on risk rating
    const getColors = (rating) => {
        switch (rating) {
            case 'Very High':
            case 'High':
                return {
                    background: 'var(--related_red)',
                    useWhiteIcon: true
                };
            case 'Relatively High':
                return {
                    background: 'var(--related_red)',
                    useWhiteIcon: true
                };
            case 'Medium':
            case 'Moderate':
                return {
                    background: 'var(--yellow)',
                    useWhiteIcon: true
                };
            case 'Low':
                return {
                    background: 'var(--grey)',
                    useWhiteIcon: false
                };
            default:
                return {
                    background: 'var(--very-light-grey)',
                    useWhiteIcon: false
                };
        }
    };

    // Get the icon URL based on whether we need to look it up or use it directly
    const getIconUrl = () => {
        const colors = getColors(risk_level);
        const useWhiteIcon = colors.useWhiteIcon;
        const icon_filename = useWhiteIcon ? icon_white : icon_black;

        let icon_filepath = icon_filename;
        if (requiresLookup && icons) {
            icon_filepath = icons[icon_filename];
        }

        return CreateCloudfrontUrl(icon_filepath);
    };

    return (
        <div
            key={id}
            className={`climate-in-your-area-risk-item ${notSelected}`}
        >
            <div
                className="climate-in-your-area-risk-icon-container box-shadow-standard"
                style={{ backgroundColor: getColors(risk_level).background }}
            >
                <img
                    src={getIconUrl()}
                    alt={`Quoll ${risk_name} icon`}
                    className="climate-in-your-area-risk-icon"
                    onMouseEnter={() => handleMouseEnter?.(id)}
                    onMouseLeave={handleMouseLeave}
                />
            </div>
            {displayName && <span className="climate-in-your-area-risk-type">{risk_name}</span>}
        </div>
    );
};

export default RiskOverviewClimateIcon;